import Blue from "~/core";

new Blue({
  name: "site modals",
  selector: ".site-modals__modal--cookies",
  setup(cookies) {
    const closeBtn = cookies.querySelector(".site-modals__modal-close");
    const accept = cookies.querySelector(".site-modals__modal-accept");
    const decline = cookies.querySelector(".site-modals__modal-decline");
    const storage = window.localStorage;

    const checkForResponse = () => {
      return storage.getItem("acceptedCookies");
    };

    const closeCookies = () => {
      cookies.classList.remove("site-modals__modal--active");
      cookies.classList.add("site-modals__modal--dismissed");
    };

    const loadOptInGtm = async () => {
      //first remove existing node
      // var existing = document.getElementById("tagmanager");
      // if (existing && existing.parentNode) {
      //   existing.parentNode.removeChild(existing);
      // }
      //console.log("adding node to head...");

      var gtmRespone = await fetch("/api/cookies/gtmoptin", {
        method: "POST"
      });

      var gtm = await gtmRespone.text();
      let node = document.createElement("script");
      node.textContent = gtm;
      node.type = "text/javascript";
      node.async = true;
      node.charset = "utf-8";
      node.setAttribute("id", "tagmanager_optin");
      document.getElementsByTagName("head")[0].appendChild(node);
    };

    const setCookies = async consent => {
      var response = await fetch("/api/cookies/consent", {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify(consent)
      });

      var result = await response.json();

      storage.setItem("acceptedCookies", result);

      if (consent) {
        loadOptInGtm();
      }

      closeCookies();
    };

    setTimeout(() => {
      cookies.classList.add("site-modals__modal--active");
      closeBtn.setAttribute("tabindex", 1);
      accept.setAttribute("tabindex", 1);
      decline.setAttribute("tabindex", 1);
      closeBtn.focus();
    }, 750);

    this.$addEvents(closeBtn, "click enter", closeCookies);
    this.$addEvents(decline, "click enter", () => {
      setCookies(false);
    });
    this.$addEvents(accept, "click enter", () => {
      setCookies(true);
    });
  }
});
